"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheSelectOptions = exports.defaultFilterOptions = exports.defaultFilterFunction = exports.containsExactMatch = exports.getDefaultCreateOption = exports.isOptionSelected = void 0;
const tslib_1 = require("tslib");
const Options_1 = require("./Options");
const utilities_1 = require("../utilities");
const react_1 = tslib_1.__importDefault(require("react"));
const at_1 = tslib_1.__importDefault(require("@sportnet/utilities/at"));
const removeAccents_1 = tslib_1.__importDefault(require("@sportnet/utilities/removeAccents"));
function isOptionSelected(option, value) {
    if (Array.isArray(value)) {
        return !!value.find(v => {
            return v.value === option.value;
        });
    }
    else if (value) {
        return value.value === option.value;
    }
    return false;
}
exports.isOptionSelected = isOptionSelected;
function getDefaultCreateOption(inputValue, label) {
    return {
        value: Options_1.CREATE_OPTION_VALUE,
        label: `${label || (0, utilities_1.__)('Vytvoriť novú možnosť')} "${inputValue}"`,
    };
}
exports.getDefaultCreateOption = getDefaultCreateOption;
function containsExactMatch(options, inputValue) {
    return options.findIndex(option => String(option.value) === inputValue) > -1;
}
exports.containsExactMatch = containsExactMatch;
const defaultFilterFunction = (option, inputValue) => {
    const haystack = `${(0, removeAccents_1.default)(String(option.label)).toLowerCase()} ${(0, removeAccents_1.default)(String(option.value)).toLowerCase()}`;
    return haystack.indexOf((0, removeAccents_1.default)(inputValue).toLowerCase()) > -1;
};
exports.defaultFilterFunction = defaultFilterFunction;
const defaultFilterOptions = (options, inputValue) => {
    return options.filter(option => (0, exports.defaultFilterFunction)(option, inputValue));
};
exports.defaultFilterOptions = defaultFilterOptions;
function isMultiple(value, multiple) {
    return multiple;
}
function useTheSelectOptions(items, formatOption, value, deps, { multiple = false, } = {}) {
    const [options, setOptions] = react_1.default.useState([]);
    const [optionsByValue, setOptionsByValue] = react_1.default.useState({});
    react_1.default.useEffect(() => {
        const newOptionsByValue = {};
        const newOptions = items.map(unformattedOption => {
            const formattedOption = formatOption(unformattedOption);
            newOptionsByValue[String(formattedOption.value)] = formattedOption;
            return formattedOption;
        });
        setOptions(newOptions);
        setOptionsByValue(newOptionsByValue);
    }, deps);
    const selectedOption = react_1.default.useMemo(() => {
        if (isMultiple(value, !!multiple)) {
            return (0, at_1.default)(optionsByValue, value.map(String));
        }
        const stringValue = String(value);
        return stringValue in optionsByValue ? optionsByValue[stringValue] : null;
    }, [optionsByValue, value, multiple]);
    return [options, selectedOption, optionsByValue];
}
exports.useTheSelectOptions = useTheSelectOptions;
